export default __webpack_public_path__ + "static/assets/med_x_powder_2_mask.cadecc57.png";